import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './authentication/authentication.service';
import { AlertService } from './alert/alert.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService,
    private alertService: AlertService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('lmsAccessToken');

    // Add token to LMS API requests
    if (req.url.includes('/api/') && token) {
      req = req.clone({
        setHeaders: {
          "x-auth-token": `${token}`
        }
      });
    }

    // Handle unauthorized error
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.alertService.presentErrorAlert(error.message);
          this.authService.logout(); // Remove tokens and redirect
        }
        // Interceptor for maintenance
        if (error.status === 503) {
          this.router.navigate(['/maintenance'], {
            state: {
              errorCode: error.error.errorCode,
              errorMessage: error.error.errorMessage
            }
          });
        }
        return throwError(error);;
      })
    );
  }
}